import { Action, combineReducers, configureStore, ThunkAction, ThunkDispatch, AnyAction } from '@reduxjs/toolkit';
import { createReduxEnhancer } from '@sentry/react';
import analyticsReducer from './modules/analytics/analyticsSlice';
import appReducer from './modules/app/appSlice';
import authReducer from './modules/auth/authSlice';
import faqsReducer from './modules/faq/faqSlice';
import impactReducer from './modules/impact/impactSlice';
import carbonOffsetReducer from './modules/offset/carbonSlice';
import eventOffsetReducer from './modules/offset/eventSlice';
import simpleCarbonOffsetReducer from './modules/offset/simpleCarbonSlice';
import simpleEventOffsetReducer from './modules/offset/simpleEventSlice';
import simpleFlightOffsetReducer from './modules/offset/simpleFlightSlice';
import flightOffsetReducer from './modules/offset/flightSlice';
import shippingOffsetReducer from './modules/offset/shippingSlice';
import ordersReducer from './modules/orders/ordersSlice';
import paymentsReducer from './modules/payments/paymentsSlice';
import projectReducer from './modules/projects/projectsSlice';
import storiesReducer from './modules/stories/storiesSlice';
import carLoansReducer from './modules/subscriptions/carLoansSlice';
import employeeBenefitReducer from './modules/subscriptions/employeeBenefitSlice';
import subscriptionReducer from './modules/subscriptions/subscriptionSlice';
import termsReducer from './modules/terms/termsSlice';
import transactionsReducer from './modules/transactions/transactionsSlice';
import userReducer from './modules/user/userSlice';
import allUsersReducer from './modules/allUsers/allUsersSlice';
import attributionReducer from './modules/user/attributionSlice';
import signUpReducer from './modules/signUp/signUpSlice';
import toasterReducer from './modules/app/toasterSlice';
import personalFlightOffsetReducer from './modules/offset/personalFlightSlice';
import personalCarbonOffsetReducer from './modules/offset/personalCarbonSlice';
import personalEventOffsetReducer from './modules/offset/personalEventSlice';
import personalSubscriptionReducer from './modules/offset/personalSubscriptionSlice';
import billingReducer from './modules/billing/billingSlice';
import giftCardReducer from './modules/offset/giftSlice';
import certificatesReducer from './modules/user/certificatesSlice';
import reduceReducer from './modules/reduce/reduceSlice';
import ctaReducer from './modules/cta/ctaSlice';
import offsetPortfolioSelectReducer from './modules/offset/portfolioSelectSlice';
import airFreightsReducer from './modules/offset/airFreightSlice';
import flightFootprintReducer from './modules/footprints/flightSlice';
import airFreightFootprintReducer from './modules/footprints/airFreightSlice';
import customerReducer from './modules/offset/customersSlice';

export const rootReducer = combineReducers({
  app: appReducer,
  auth: authReducer,
  user: userReducer,
  eventOffset: eventOffsetReducer,
  simpleEventOffset: simpleEventOffsetReducer,
  carbonOffset: carbonOffsetReducer,
  simpleCarbonOffset: simpleCarbonOffsetReducer,
  flightOffset: flightOffsetReducer,
  airFreight: airFreightsReducer,
  simpleFlightOffset: simpleFlightOffsetReducer,
  shippingOffset: shippingOffsetReducer,
  orders: ordersReducer,
  impact: impactReducer,
  employeeBenefit: employeeBenefitReducer,
  projects: projectReducer,
  faqs: faqsReducer,
  stories: storiesReducer,
  carLoans: carLoansReducer,
  subscriptions: subscriptionReducer,
  transactions: transactionsReducer,
  analytics: analyticsReducer,
  terms: termsReducer,
  payments: paymentsReducer,
  allUsers: allUsersReducer,
  attribution: attributionReducer,
  signUp: signUpReducer,
  toaster: toasterReducer,
  flightOffsetPersonal: personalFlightOffsetReducer,
  carbonOffsetPersonal: personalCarbonOffsetReducer,
  personalEventOffset: personalEventOffsetReducer,
  personalSubscription: personalSubscriptionReducer,
  offsetPortfolioSelect: offsetPortfolioSelectReducer,
  billing: billingReducer,
  giftCard: giftCardReducer,
  certificates: certificatesReducer,
  reduce: reduceReducer,
  cta: ctaReducer,
  flightFootprint: flightFootprintReducer,
  airFreightFootprint: airFreightFootprintReducer,
  offsetCustomers: customerReducer,
});

const sentryReduxEnhancer = createReduxEnhancer({});

const store = configureStore({
  reducer: rootReducer,
  enhancers: defaultEnhancers => [sentryReduxEnhancer, ...defaultEnhancers],
});

export default store;

export type RootState = ReturnType<typeof rootReducer>;
export type TypedDispatch = ThunkDispatch<RootState, null, AnyAction>;
export type AppThunk = ThunkAction<void, RootState, null, Action<string>>;
